var render, staticRenderFns
import script from "./s-button.vue?vue&type=script&lang=js&"
export * from "./s-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e78914')) {
      api.createRecord('48e78914', component.options)
    } else {
      api.reload('48e78914', component.options)
    }
    
  }
}
component.options.__file = "themes/default/src/components/ui-components/s-button/s-button.vue"
export default component.exports